import React from 'react';
import AttachedFile from '@wix/da-ds/pkg/AttachedFile';
import s from './AttachmentsList.scss';
const LIST_MAX_VISIBLE_ITEMS = 100;
const AttachmentsList = ({ assets =[]  })=>{
    if (assets.length < 1) {
        return null;
    }
    const visibleAssets = assets.slice(0, LIST_MAX_VISIBLE_ITEMS);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, visibleAssets.map((asset, idx)=>/*#__PURE__*/ React.createElement(AttachedFile, {
            className: s['attachment'],
            key: `asset-${idx}`,
            name: asset.filename,
            size: asset.filesize,
            type: asset.type,
            width: asset.width,
            height: asset.height
        })));
};
AttachmentsList.displayName = 'AttachmentsList';
export default AttachmentsList;
